export default __webpack_public_path__ + "static/media/stamp_2.57d2134e.png";